<template>
  <pre>{{ row.payload }}</pre>
</template>

<script>
export default {
  name: 'payload-cell',
  props: {
    row: Object
  }
}
</script>



// WEBPACK FOOTER //
// PayloadCell.vue?8f974f2a